import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var DetailReportCtrl = function (fn, er, values, token, ids) {

	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},

	};
	var data = {
		card: values.numCarta !== '' ? values.numCarta : '',
		startDate: values.startDateOut,
		endDate: values.endDateOut,
		cod: sessionStorage.getItem('code') !== '' ? sessionStorage.getItem('code') : '',
		state: values.valueDisputa !== '' ? values.valueDisputa : '' 
	};


	axios
		.post(ApiConfig.url.DETAIL_REPORT, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});


}

export { DetailReportCtrl };